import GATSBY_COMPILED_MDX from "/codebuild/output/src1736506255/src/elearnis-2020/data/fr/_pages/contact/contact.md";
import React, {useState} from 'react';
import Layout from '../layouts/Layout';
import SEO from '../components/SEO';
import axios from 'axios';
import {graphql} from 'gatsby';
import {useInput} from '../hooks/useInput';
import MarkdownContent from '../components/MarkdownContent';
import Activity from '../components/Activity';
import ContactPhoto from '../assets/images/contact-photo.jpg';
import {ReactComponent as SVGphone} from '../assets/svg/phone.svg';
import {ReactComponent as SVGmail} from '../assets/svg/mail.svg';
import {ReactComponent as SVGlinkedin} from '../assets/svg/linkedin.svg';
import {ReactComponent as SVGtwitter} from '../assets/svg/twitter.svg';
function Contact({location, data}) {
  const {i18NJson: i18n, site: {siteMetadata: {contact: {conversionId: contactConversionId, url: contactUrl}}}} = data;
  const page = data.allMdx.edges.find(({node: {fields: {block}}}) => block === null).node;
  const blocks = data.allMdx.edges.reduce((acc, {node: {id, body, fields: {block}}}) => {
    return {
      ...acc,
      [block]: {
        id,
        body
      }
    };
  }, {});
  const metaTitle = page.frontmatter.title;
  const metaDescription = page.frontmatter.description;
  const [formState, setFormState] = useState('default');
  const {value: name, bind: bindName, reset: resetName} = useInput('');
  const {value: company, bind: bindCompany, reset: resetCompany} = useInput('');
  const {value: email, bind: bindEmail, reset: resetEmail} = useInput('');
  const {value: phone, bind: bindPhone, reset: resetPhone} = useInput('');
  const {value: message, bind: bindMessage, reset: resetMessage} = useInput('');
  const handleSubmit = evt => {
    evt.preventDefault();
    setFormState('loading');
    console.warn(`Submitting Name ${name}, company ${company}, email ${email}, phone ${phone}, message ${message}`);
    axios.post(contactUrl, {
      name,
      company,
      email,
      phone,
      message
    }).then(response => {
      if (response.data?.statusCode !== 200) {
        console.error('error');
        setFormState('error');
      } else {
        console.log('success');
        resetName();
        resetCompany();
        resetEmail();
        resetPhone();
        resetMessage();
        setFormState('success');
        try {
          window.gtag('event', 'conversion', {
            send_to: contactConversionId
          });
        } catch {}
      }
    }).catch(() => {
      console.error('error');
      setFormState('error');
    });
  };
  const resetFormState = evt => {
    evt.preventDefault();
    setFormState('default');
  };
  return React.createElement(Layout, {
    className: "page-contact"
  }, React.createElement(SEO, {
    pathname: location.pathname,
    title: metaTitle,
    description: metaDescription
  }), React.createElement("div", {
    className: "screen screen-contact"
  }, React.createElement("section", {
    className: "main-content"
  }, React.createElement("section", {
    className: "form"
  }, React.createElement("div", {
    className: "container"
  }, React.createElement("div", {
    className: "intro"
  }, React.createElement("header", null, React.createElement("h1", {
    className: "sub-title"
  }, i18n.ui.contactFormTitle)), React.createElement("div", {
    className: "content-intro"
  }, React.createElement(MarkdownContent, null, blocks.intro.body)), React.createElement("figure", {
    className: "photo"
  }, React.createElement("img", {
    src: ContactPhoto,
    alt: ""
  }))), React.createElement("div", {
    className: "form-wrapper"
  }, React.createElement("form", {
    onSubmit: handleSubmit,
    "aria-busy": formState === 'loading',
    disabled: formState === 'loading'
  }, React.createElement("fieldset", {
    hidden: formState !== 'default'
  }, React.createElement("div", {
    className: "form-group"
  }, React.createElement("label", {
    htmlFor: "contactFormName"
  }, i18n.ui.contactFormNameLabel), React.createElement("input", Object.assign({
    type: "text",
    name: "name",
    id: "contactFormName",
    className: "form-control",
    autoComplete: "name",
    autoCorrect: "off",
    autoCapitalize: "on",
    spellCheck: "false",
    placeholder: i18n.ui.contactFormNamePlaceholder
  }, bindName, {
    required: true
  }))), React.createElement("div", {
    className: "form-group"
  }, React.createElement("label", {
    htmlFor: "contactFormCompany"
  }, i18n.ui.contactFormCompanyLabel), React.createElement("input", Object.assign({
    type: "text",
    name: "company",
    id: "contactFormCompany",
    className: "form-control",
    autoComplete: "organization",
    autoCorrect: "off",
    autoCapitalize: "on",
    spellCheck: "false",
    placeholder: i18n.ui.contactFormCompanyPlaceholder
  }, bindCompany, {
    required: true
  }))), React.createElement("div", {
    className: "form-group"
  }, React.createElement("label", {
    htmlFor: "contactFormEmail"
  }, i18n.ui.contactFormEmailLabel), React.createElement("input", Object.assign({
    type: "email",
    name: "email",
    id: "contactFormEmail",
    className: "form-control",
    autoComplete: "email",
    autoCorrect: "off",
    autoCapitalize: "on",
    spellCheck: "false",
    placeholder: i18n.ui.contactFormEmailPlaceholder
  }, bindEmail, {
    required: true
  }))), React.createElement("div", {
    className: "form-group"
  }, React.createElement("label", {
    htmlFor: "contactFormTelephone"
  }, i18n.ui.contactFormTelephoneLabel), React.createElement("input", Object.assign({
    type: "text",
    name: "telephone",
    id: "contactFormTelephone",
    className: "form-control",
    autoComplete: "tel",
    autoCorrect: "off",
    autoCapitalize: "on",
    spellCheck: "false",
    placeholder: i18n.ui.contactFormTelephonePlaceholder
  }, bindPhone, {
    required: true
  }))), React.createElement("div", {
    className: "form-group message"
  }, React.createElement("label", {
    htmlFor: "contactFormTMessage"
  }, i18n.ui.contactFormMessageLabel), React.createElement("textarea", Object.assign({
    className: "form-control",
    rows: "8",
    name: "message",
    id: "contactFormTMessage",
    placeholder: i18n.ui.contactFormMessagePlaceholder
  }, bindMessage, {
    required: true
  }))), React.createElement("div", {
    className: "form-group action"
  }, React.createElement("button", {
    type: "submit",
    className: "btn btn-primary btn-lg",
    "data-loading-text": "<i class='fa fa-circle-o-notch fa-spin'></i> {i18n.ui.contactFormSendLabel_loading}"
  }, i18n.ui.contactFormSendLabel, ' ', React.createElement("i", {
    className: "fa fa-arrow-right"
  })))), formState === 'success' && React.createElement("div", {
    className: "feedback"
  }, React.createElement("div", {
    className: "alert alert-success"
  }, React.createElement(MarkdownContent, null, i18n.ui.contactFormSuccess), React.createElement("p", null, React.createElement("button", {
    type: "button",
    className: "btn btn-default",
    onClick: resetFormState
  }, i18n.ui.contactFormOK)))), formState === 'error' && React.createElement("div", {
    className: "feedback"
  }, React.createElement("div", {
    className: "alert alert-danger"
  }, React.createElement("p", null, React.createElement("i", {
    className: "fa fa-exclamation-circle"
  }), ' ', "ERROR"), React.createElement("p", null, React.createElement("button", {
    type: "button",
    className: "btn btn-default",
    onClick: resetFormState
  }, i18n.ui.contactFormOK)))), formState === 'loading' && React.createElement("div", {
    "data-rel": "loading"
  }, React.createElement(Activity)))))), React.createElement("section", {
    className: "infos"
  }, React.createElement("div", {
    className: "container"
  }, React.createElement("div", {
    className: "card"
  }, React.createElement("a", {
    href: "tel:+33458003868"
  }, React.createElement("header", null, React.createElement("h2", null, i18n.ui.contactTelephoneHeader)), React.createElement("figure", {
    className: "icon"
  }, React.createElement(SVGphone)), React.createElement("span", {
    className: "text"
  }, "+33 (0)4 58 00 38 68"))), React.createElement("div", {
    className: "card"
  }, React.createElement("a", {
    href: "mailto:contact@elearnis.fr"
  }, React.createElement("header", null, React.createElement("h2", null, i18n.ui.contactEmailHeader)), React.createElement("figure", {
    className: "icon"
  }, React.createElement(SVGmail)), React.createElement("span", {
    className: "text"
  }, "contact@elearnis.fr"))), React.createElement("div", {
    className: "card"
  }, React.createElement("a", {
    href: "https://www.linkedin.com/company/2376894"
  }, React.createElement("header", null, React.createElement("h2", null, i18n.ui.contactLinkedinHeader)), React.createElement("figure", {
    className: "icon"
  }, React.createElement(SVGlinkedin)), React.createElement("span", {
    className: "text"
  }, "LinkedIn"))), React.createElement("div", {
    className: "card"
  }, React.createElement("a", {
    href: "https://twitter.com/elearnis"
  }, React.createElement("header", null, React.createElement("h2", null, i18n.ui.contactTwitterHeader)), React.createElement("figure", {
    className: "icon"
  }, React.createElement(SVGtwitter)), React.createElement("span", {
    className: "text"
  }, "Twitter"))))), React.createElement("section", {
    className: "map"
  }, React.createElement("div", {
    className: "container"
  }, React.createElement("iframe", {
    title: "Map",
    width: "600",
    height: "450",
    style: {
      border: 0
    },
    loading: "lazy",
    allowFullScreen: true,
    src: "https://www.google.com/maps/embed/v1/place?q=place_id:ChIJ-6fA8br1ikcRBqLsdUh31B8&key=AIzaSyDjC_iEri6n0xLiFlByMpQN1ctDRp5nssE&zoom=6"
  }))))));
}
export default function GatsbyMDXWrapper(props) {
  return React.createElement(Contact, props, React.createElement(GATSBY_COMPILED_MDX, props));
}
export const query = graphql`
	{
		allMdx(
			filter: {
				fields: { collection: { eq: "pages" }, page: { eq: "contact" } }
			}
		) {
			edges {
				node {
					id
					body
					fields {
						collection
						page
						block
					}
					frontmatter {
						title
						description
					}
				}
			}
		}
		i18NJson {
			ui {
				contactFormTitle
				contactFormNameLabel
				contactFormNamePlaceholder
				contactFormCompanyLabel
				contactFormCompanyPlaceholder
				contactFormEmailLabel
				contactFormEmailPlaceholder
				contactFormTelephoneLabel
				contactFormTelephonePlaceholder
				contactFormMessageLabel
				contactFormMessagePlaceholder
				contactFormSendLabel_loading
				contactFormSendLabel
				contactFormSuccess
				contactFormOK

				contactTelephoneHeader
				contactEmailHeader
				contactLinkedinHeader
				contactTwitterHeader
			}
		}
		site {
			siteMetadata {
				contact {
					conversionId
					url
				}
			}
		}
	}
`;
